import axios from "../axios/axios";
import {
  ItemSearchRequest,
  ItemBasicResponse,
  PageResponse,
} from "../types/medicineSearch.types";

// Global item search adapter for POST /search/item (PR 1).
//
// Shape matches SearchFn<ItemBasicResponse>: (normalizedQuery, signal) => Promise<T[]>.
// The hook (useDebouncedSearch) owns debounce/abort/normalization; this adapter
// only builds the verified request body and unwraps the page envelope.

const PAGE_SIZE = 50;

export const searchMedicineItems = (
  normalizedQuery: string,
  signal: AbortSignal
): Promise<ItemBasicResponse[]> => {
  const request: ItemSearchRequest = {
    partialName: normalizedQuery, // already trimmed + length-gated by the hook
    pageNum: 0,
    pageSize: PAGE_SIZE,
    sort: ["relevanceScore:desc"],
    // Optional filters omitted entirely: the backend setters throw on explicit null.
  };

  // baseURL already ends with /apoteka_rs_server, so the path is just '/search/item'.
  return axios
    .post<PageResponse<ItemBasicResponse>>("/search/item", request, { signal })
    .then((res) => res.data.elements);
};
